import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'CmgNonMemberRewards',
})
export default class CmgNonMemberRewards extends Vue {
}
